<template>
    <div>
        <div class="menu-nav-bar">
            <div class="container">
                <b-navbar toggleable="lg" type="dark">
                    <b-navbar-brand href="/">Д<b-icon icon="patch-question-fill" font-scale="1"
                            variant="light"></b-icon>С</b-navbar-brand>
                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                    <b-collapse id="nav-collapse" is-nav>
                        <b-navbar-nav class="ms-auto">
                            <b-nav-item v-if="$store.getters.AUTHORIZE" :to="{ path: '/personalcabinet' }">Личный
                                кабинет</b-nav-item>
                            <b-nav-item v-if="$store.getters.AUTHORIZE" :to="{ path: '/grades' }">Оценки</b-nav-item>
                            <b-nav-item href="/contact">Контакты</b-nav-item>
                            <b-nav-item v-if="$store.getters.AUTHORIZE" @click="logOut()">Выход</b-nav-item>
                            <b-nav-item v-if="!$store.getters.AUTHORIZE" :to="{ path: '/' }">Вход</b-nav-item>
                        </b-navbar-nav>
                    </b-collapse>
                </b-navbar>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        logOut() {
            // this.$store.commit('authorize', false);
            this.setLogOut();
            // this.$store.commit('reDirect', '/');
        },
        setLogOut() {
            this.axios
                .get(this.$store.getters.URL + '/account/logout')
                .then(response => (this.$store.commit('reDirect', response.data.redirect),
                    this.$store.commit('authorize', false)
                ));
        },
    },
}
</script>
<style>
 #app .navbar-brand {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 26px;
    font-weight: 900;
}
/*
nav {
    padding: 30px;
}


#app .nav-link {
    color: #d5d5d5;
}

#app .nav-link:hover {
    color: #d5d5d5;
}

#app .nav-item .router-link-exact-active {
    color: #ffffff;
}

#nav-collapse {
    position: relative;
    min-height: 50px;
    margin-bottom: 20px;
    border: 1px solid transparent;
}

.menu-nav-bar {
 
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
} */
</style>